import { Component, OnInit, Input , ChangeDetectionStrategy } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
    selector: 'app-multi-stake-modal',
    templateUrl: './multi-stake-modal.component.html',
    styleUrls: ['./multi-stake-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MultiStakeModalComponent implements OnInit {

  @Input() src;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

}
